import { render, staticRenderFns } from "./TestInstallmentOrderListVn.vue?vue&type=template&id=193dde8f&scoped=true"
import script from "./TestInstallmentOrderListVn.vue?vue&type=script&lang=js"
export * from "./TestInstallmentOrderListVn.vue?vue&type=script&lang=js"
import style0 from "./TestInstallmentOrderListVn.vue?vue&type=style&index=0&id=193dde8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193dde8f",
  null
  
)

export default component.exports